"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/Accordion";
import { cn } from "@/lib/utils";

import type { FaqAccordionProps } from "./FaqAccordion.types";

/**
 * FAQ list in the film style: hairline rules instead of cards and a small
 * slate number per question. The number is decorative, so each question keeps
 * its own text as the accessible name.
 */
export const FaqAccordion = ({ items, className }: FaqAccordionProps) => {
  const firstItemId = items[0]?.id;

  return (
    <Accordion
      defaultValue={firstItemId ? [firstItemId] : []}
      className={cn("flex flex-col border-t border-border", className)}
    >
      {items.map((item, index) => (
        <AccordionItem
          key={item.id}
          value={item.id}
          className="border-b border-border"
        >
          <AccordionTrigger className="gap-4 rounded-none py-5 text-base hover:no-underline sm:gap-6">
            <span className="flex min-w-0 flex-1 items-baseline gap-4 sm:gap-6">
              <span
                aria-hidden
                className="w-6 shrink-0 text-[11px] font-medium tabular-nums tracking-[0.2em] text-muted-foreground"
              >
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className="min-w-0 text-pretty">{item.question}</span>
            </span>
          </AccordionTrigger>
          <AccordionContent className="pb-6 pl-10 pr-8 leading-relaxed text-muted-foreground sm:pl-12 sm:text-[0.9375rem]">
            {item.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
